import React, { useState, useEffect } from "react";
import '../../assets/styles/AdminShared.css';
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase-config"; // Ensure correct Firebase Firestore setup
import { useParams } from "react-router-dom";

const AdminWebContent = () => {
  const { projectId } = useParams(); // Get the projectId from the URL
  const [activePage, setActivePage] = useState("home");
  const [webContent, setWebContent] = useState({});
  const [projectName, setProjectName] = useState(""); // State to store project name
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const pages = [
    { id: "home", title: "Home", sections: [{ id: "header", label: "Header" }, { id: "intro", label: "Intro" }, { id: "callToAction", label: "Call to Action" }] },
    { id: "about", title: "About Us", sections: [{ id: "mission", label: "Mission" }, { id: "vision", label: "Vision" }, { id: "team", label: "Team" }] },
    { id: "contact", title: "Contact", sections: [{ id: "address", label: "Address" }, { id: "phone", label: "Phone" }, { id: "email", label: "Email" }] },
    { id: "services/products", title: "Services/Products", sections: [{ id: "overview", label: "Overview" }, { id: "service1", label: "Service 1" }, { id: "service2", label: "Service 2" }] },
    { id: "portfolio", title: "Portfolio", sections: [{ id: "showcaseIntro", label: "Showcase Intro" }, { id: "project1", label: "Project 1" }, { id: "project2", label: "Project 2" }] },
  ];

  useEffect(() => {
    if (!projectId) return;

    const fetchWebContent = async () => {
      try {
        setLoading(true);
        const projectRef = doc(db, "projects", projectId);
        const projectSnap = await getDoc(projectRef);

        if (projectSnap.exists()) {
          const projectData = projectSnap.data();
          setWebContent(projectData.webContent || {});
          setProjectName(projectData.projectName || "Unnamed Project"); // Set project name
        } else {
          setError("Project not found.");
        }
      } catch (error) {
        console.error("Error fetching web content:", error);
        setError("Failed to fetch web content.");
      } finally {
        setLoading(false);
      }
    };

    fetchWebContent();
  }, [projectId]);

  const handleInputChange = (pageId, sectionId, value) => {
    setWebContent((prev) => ({
      ...prev,
      [pageId]: {
        ...prev[pageId],
        [sectionId]: value,
      },
    }));
  };

  const handleSave = async () => {
    try {
      const projectRef = doc(db, "projects", projectId);
      await updateDoc(projectRef, { webContent });
      alert("Web content saved successfully!");
    } catch (error) {
      console.error("Error saving web content:", error);
      alert("Failed to save web content.");
    }
  };

  return (
    <div className="ap-page">
      <div className="ap-page-header">
        <a href={`/admin/project/${projectId}`} className="ap-back">← Back to project</a>
        <p className="ap-eyebrow">Admin</p>
        <h1 className="ap-title">Web Content — {projectName}</h1>
        <p className="ap-subtitle">View or edit the client-submitted website copy for each page.</p>
      </div>

      {loading ? <div className="ap-loading"><p>Loading...</p></div>
       : error ? <div className="ap-loading ap-loading--error"><p>{error}</p></div>
       : (
        <div className="ap-section">
          {/* Tab bar */}
          <div className="ap-tab-bar">
            {pages.map(page => (
              <button key={page.id} className={`ap-tab${activePage === page.id ? ' active' : ''}`} onClick={() => setActivePage(page.id)} type="button">
                {page.title}
              </button>
            ))}
          </div>
          {/* Content for active page */}
          <div className="ap-section-body">
            {pages.find(p => p.id === activePage)?.sections.map(({ id, label }) => (
              <div key={id} className="ap-form-group">
                <label>{label}</label>
                <textarea value={webContent[activePage]?.[id] || ""} onChange={(e) => handleInputChange(activePage, id, e.target.value)} placeholder={`Write content for ${label}`} />
              </div>
            ))}
            <div className="ap-btn-row">
              <button className="ap-btn-primary" onClick={handleSave} type="button">Save Changes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminWebContent;
